import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { getFriendlyError } from '../../utils/error';
import { PropertyRequestParams } from '../properties/types';
import { getProductCategories } from './products';
import { ApiProductCategory, ProductCategory } from './types';

export const PRODUCTS_QUERY_KEY = 'products';

export interface UseProductCategories {
  isLoading: boolean;
  data: ProductCategory[] | undefined;
  error: string | undefined;
}

export interface UseProductCategoriesRequest extends PropertyRequestParams {
  propertyId?: string;
}

export const useProductCategories = ({
  propertyId,
  interval,
  buildingAttributeHash,
}: UseProductCategoriesRequest): UseProductCategories => {
  const { data, error, isLoading } = useQuery<ApiProductCategory[], AxiosError>({
    queryKey: [PRODUCTS_QUERY_KEY, interval, buildingAttributeHash],
    queryFn: () => getProductCategories(),
    enabled: Boolean(propertyId),
  });

  return {
    data: data as ProductCategory[] | undefined,
    error: error ? getFriendlyError(error, 'product categories') : undefined,
    isLoading,
  };
};

export default useProductCategories;
